import { useEffect, useRef } from "react";

export const useEffectOnce = (effect: React.EffectCallback): void => {
  const effectRan = useRef(false);

  useEffect(() => {
    if (!effectRan.current) {
      effect();
    }

    return () => { effectRan.current = true };
  }, [effect])
}